import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Idea } from '@models/Sessions/Idea/Idea';
import { Session } from '@models/Sessions/Session';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'idea-picker',
  templateUrl: './idea-picker.component.html',
  styleUrls: ['./idea-picker.component.scss'],
  host: {
    '[class.d-flex]': 'true',
    '[class.gap-2]': 'true',
    '[class.flex-wrap]': 'true',
  },
})
export class IdeaPickerComponent {
  @Input() ideas: Idea[];
  @Input() session: Session;
  @Input() picked: Idea[] = [];
  @Output() pickedChange = new EventEmitter<Idea[]>();

  isPicked(idea: Idea): boolean {
    return (
      this.picked.find(_idea => _idea._id.toString() === idea._id.toString()) !=
      undefined
    );
  }

  toggle(idea: Idea) {
    if (idea) {
      if (this.isPicked(idea)) {
        this.picked = this.picked.filter(
          _idea => _idea._id.toString() != idea._id.toString(),
        );
      } else {
        this.picked.push(idea);
      }
      this.pickedChange.emit(this.picked);
    }
  }
}
